/**
 * Grozaro offer PDP — pack cards + quantity for Buy It Now panel
 */
(function () {
  function init(root) {
    if (!root || root.dataset.offerReady === '1') return;
    root.dataset.offerReady = '1';

    const form = root.querySelector('.grozaro-offer-panel__form');
    const qtyHidden = root.querySelector('[data-offer-qty-hidden]');
    const qtyValue = root.querySelector('[data-offer-qty-value]');
    const packs = [...root.querySelectorAll('[data-offer-pack]')];
    const minus = root.querySelector('[data-offer-qty-minus]');
    const plus = root.querySelector('[data-offer-qty-plus]');

    let qty = 1;

    function setQty(next) {
      qty = Math.max(1, Math.min(20, Number(next) || 1));
      if (qtyHidden) qtyHidden.value = String(qty);
      if (qtyValue) qtyValue.textContent = String(qty);

      // Keep theme/Shiprocket quantity inputs in sync if present
      document.querySelectorAll('input[name="quantity"]').forEach((input) => {
        if (input !== qtyHidden) input.value = String(qty);
      });
      document.querySelectorAll('quantity-selector-component input, .quantity-input').forEach((input) => {
        input.value = String(qty);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    function selectPack(pack) {
      packs.forEach((el) => {
        const on = el === pack;
        el.classList.toggle('is-selected', on);
        el.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      setQty(pack.dataset.qty || 1);
    }

    packs.forEach((pack) => {
      pack.addEventListener('click', () => selectPack(pack));
    });

    minus?.addEventListener('click', () => setQty(qty - 1));
    plus?.addEventListener('click', () => setQty(qty + 1));

    setQty(1);
  }

  function boot() {
    document.querySelectorAll('[data-grozaro-offer-panel]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
